import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'

import FormatCheckTextBox from '../../../common/component/FormatCheckTextBox'
import Window from '../../../common/Window'

class CommonPasswordChange extends Component {
  constructor (props) {
    super(props)
    this.state = {currentPassword: '', newPassword: '', newPasswordVerification: '', currentPasswordOK: false, newPasswordOK: false, newPasswordVerificationOK: false}
  }
  changed (name, e, isError) {
    this.setState({[name]: e.target.value, [name + 'OK']: !isError})
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'back':
        this.props.history.push('/' + this.userRoleUrl + '/personal_setting_home/')
        break
      default:
        break
    }
  }
  onFormButtonClicked (name, e) {
    e.preventDefault()
    switch (name) {
      case 'changePassword':
        const currentPassword = this.state.currentPassword.trim()
        const newPassword = this.state.newPassword.trim()
        const newPasswordVerification = this.state.newPasswordVerification.trim()
        if (currentPassword === '') {
          Window.alert('現在のパスワードは必須です。')
          return false
        }
        if (newPassword === '') {
          Window.alert('新しいパスワードは必須です。')
          return false
        }
        if (newPasswordVerification === '') {
          Window.alert('新しいパスワード(確認用)は必須です。')
          return false
        }
        if (newPassword.length < 8 || !newPassword.match(/^[a-z\d!#_&@]{8,256}$/i)) {
          Window.alert('パスワードは英数字か次の半角記号（!#_&@）の組み合わせ8文字以上で入力してください')
          return false
        }
        if (newPassword === newPasswordVerification) {
          AWSAPI.changePassword(this.userRole, currentPassword, newPassword, (result) => {
            Window.alert('パスワードを変更しました。', () => {
              AWSAPI.logout(this.userRole)
              this.props.history.push('/' + this.userRoleUrl + '/login')
              Window.closeDialog()
            })
          }, (err) => {
            if (err) {
              Window.alert('パスワードの更新に失敗しました。')
              return false
            }
          }
          )
        } else {
          Window.alert('新しいパスワードが新しいパスワード(確認用)と一致しません。')
          return false
        }
        break
      default:
        break
    }
  }
  renderInputNewPassword () {
    const passwordPattern = /^[a-z\d!#_&@]{8,256}$/i
    return (
      <div>
        <fieldset>
          <legend>パスワードの変更</legend><br />
          <div className='control-group'>
            <label className='control-label'>現在のパスワード <span className='required'>*</span></label>
            <div className='controls'>
              <FormatCheckTextBox type='password' className='span4' value={this.state.currentPassword} autoComplete='false' onChange={(e, isError) => this.changed('currentPassword', e, isError)} pattern={passwordPattern} placeholder='8文字以上' message='パスワードは英数字か次の半角記号（!#_&@）の組み合わせ8文字以上で入力してください' />
            </div>
          </div>
          <div className='control-group'>
            <label className='control-label'>新しいパスワード <span className='required'>*</span></label>
            <div className='controls'>
              <FormatCheckTextBox type='password' className='span4' value={this.state.newPassword} autoComplete='false' onChange={(e, isError) => this.changed('newPassword', e, isError)} pattern={passwordPattern} placeholder='8文字以上' message='パスワードは英数字か次の半角記号（!#_&@）の組み合わせ8文字以上で入力してください' />
            </div>
          </div>
          <div className='control-group'>
            <label className='control-label'>新しいパスワード <span className='required'>*</span><br />(確認用)</label>
            <div className='controls'>
              <FormatCheckTextBox type='password' className='span4' value={this.state.newPasswordVerification} autoComplete='false' onChange={(e, isError) => this.changed('newPasswordVerification', e, isError)} pattern={passwordPattern} placeholder='8文字以上' message='パスワードは英数字か次の半角記号（!#_&@）の組み合わせ8文字以上で入力してください' />
            </div>
          </div>
        </fieldset>
      </div>
    )
  }
  renderPageNavi () {
    return (
      <section className='nav-page'>
        <div className='container'>
          <div className='row'>
            <div className='span7'>
              <header className='page-header'>
                <h3>パスワードの変更<br /><small>こちらでご自身のパスワードを変更できます。</small></h3>
              </header>
            </div>
            <div className='span9'>
              <ul className='nav nav-pills'>
                <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    )
  }
  render () {
    const inputNewPassword = this.renderInputNewPassword()
    const disabledStatus = (this.state.currentPasswordOK && this.state.newPasswordOK && this.state.newPasswordVerificationOK) ? '' : 'disabled'
    console.log(this.state.newPasswordOK)
    console.log(this.state.newPasswordVerificationOK)
    return (
      <div>
        {this.renderPageNavi()}
        <section className='page container'>
          <form className='form-horizontal' method='post'>
            <div className='container'>
              <div className='alert alert-block alert-info'>
                <p>必要な情報を入力して最後に「パスワードを変更する」ボタンを押してください。「<span className='required'>*</span>」マークは必須項目です。</p>
              </div>
              {inputNewPassword}
              <footer id='submit-actions' className='form-actions'>
                <button className='btn btn-primary' onClick={(e) => this.onFormButtonClicked('changePassword', e)} disabled={disabledStatus}>パスワードを変更する</button>
              </footer>
            </div>
          </form>
        </section>
      </div>
    )
  }
}

export default CommonPasswordChange



// WEBPACK FOOTER //
// ./src/common/pages/secure/PasswordChange.js